// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e858e143","516":"be21be96","744":"c853ca94","801":"8a4c6c05"}[chunkId] + ".chunk.js";
};